export const META_PIXEL_ID = '1366878365513025'

type FbqParams = Record<string, string | number | boolean>

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[][]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

let initialized = false

/** Loads the Meta Pixel base code once and fires the initial PageView. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  if (!window.fbq) {
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq!.callMethod) {
        fbq!.callMethod(...args)
      } else {
        fbq!.queue!.push(args)
      }
    } as NonNullable<Window['fbq']>

    fbq.queue = []
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.push = fbq

    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.alt = ''
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)
  }

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/** Fires a standard Meta Pixel event. */
export function trackPixelEvent(event: string, params?: FbqParams): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, params)
}

export const PRODUCT_EVENT_PARAMS = {
  content_name: 'Functional Coach System',
  content_type: 'product',
  content_ids: 'functional-coach-system',
  value: 27,
  currency: 'USD',
} as const
